import * as Constants from '../constants'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classes from "./ContatoPage.module.css";
import { faCircleInfo, faPaperPlane, faShare } from "@fortawesome/free-solid-svg-icons";

function ContatoPage() {

  const handleClick = async (event) => {
    event.preventDefault();

    const form = event.currentTarget.closest('form');

    const nome = form.nome.value.trim();
    const email = form.email.value.trim();
    const telefone = form.telefone.value.trim();
    const mensagem = form.mensagem.value.trim();

    // Validação em JavaScript
    if (!nome) {
      alert('Por favor, preencha o seu nome.');
      form.nome.focus();
      return;
    }

    if (!email) {
      alert('Por favor, preencha o seu e-mail.');
      form.email.focus();
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Por favor, informe um e-mail válido.');
      form.email.focus();
      return;
    }

    if (!mensagem) {
      alert('Por favor, digite a sua mensagem.');
      form.mensagem.focus();
      return;
    }

    const dados = {
      nome,
      email,
      telefone: telefone || null,
      mensagem,
    };

    try {
      // Substitua 'enviar_contato.php' pelo caminho do seu script PHP
      const response = await fetch(Constants.CONTACT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dados),
      });
      console.warn(response);
      if (!response.ok) {
        throw new Error(`Erro na rede: ${response.status}`);
      }

      // Processa o retorno do PHP (esperado true ou false)
      const sucesso = await response.json();

      if (sucesso === true) {
        alert('Mensagem enviada com sucesso!');
        form.reset(); // Limpa os campos do formulário
      } else {
        alert('Houve um problema ao enviar sua mensagem. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro na requisição:', error);
      alert('Erro ao tentar conectar com o servidor.');
    }
  };

  return (
    <main>
      <section id="contato" className={classes.formulario}>
        <div className="interface">
          <h2 className="titulo">FALE<span> CONOSCO.</span></h2>

          <form>
            <input
              type="text"
              name="nome"
              id="nome"
              placeholder="Seu nome"
            />
            <input
              type="text"
              name="email"
              id="email"
              placeholder="Seu e-mail"
            />
            <input
              type="text"
              name="telefone"
              id="telefone"
              placeholder="Seu celular"
            />
            <textarea
              name="mensagem"
              id="mensagem"
              placeholder="Sua mensagem"
            ></textarea>

            <div className={classes.btnEnviar}>
              <div className={`btnContato ${classes.btnContato}`}>
                <button type="button" onClick={handleClick}>
                  <FontAwesomeIcon icon={faShare} />&nbsp;&nbsp;ENVIAR
                </button>
              </div>
            </div>
          </form>
        </div>
      </section>
      <br />
    </main>
  );
}

export default ContatoPage;